import React from 'react'
import Agents from '../agents/Agents'
const AgentsPage = () => {
  return (
    <div><Agents/></div>
  )
}

export default AgentsPage